import React from 'react';
import { motion } from 'framer-motion';
import { Download, ShieldCheck, CreditCard, Landmark, CheckCircle2 } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 overflow-hidden" data-id="element-123">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-124" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-125">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-126">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 text-white" data-id="element-127">
            MEGAPACK ABOGADO 360° <span className="text-gold-500" data-id="element-128">PRO™</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg md:text-xl text-slate-300 font-medium mb-2 max-w-3xl" data-id="element-129">
            Todo lo que un abogado necesita para trabajar, litigar, captar
            clientes y crecer profesionalmente en 2026.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-base md:text-lg text-gold-500 font-semibold mb-6 max-w-3xl" data-id="element-130">
            10 módulos completos + 5 bonos premium + cientos de recursos listos
            para usar.
          </motion.p>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="w-full max-w-2xl my-6 md:my-8" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/tPXGFzmY5k7TTXtoYRzNn4/6bfdbf5f-9527-4410-9575-fcc682fe1417.png" alt="Megapack Abogado 360 PRO: caja del producto rodeada de los módulos de modelos, IA jurídica, estrategias, gestión y herramientas profesionales" className="w-full h-auto drop-shadow-2xl" data-id="element-132" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-133">
            <p className="text-base md:text-lg text-slate-400 mb-8 max-w-2xl" data-id="element-134">
              La biblioteca profesional definitiva para abogados. Ahorrá horas
              de trabajo, actuá con mayor seguridad y dejá de depender de
              material disperso, modelos desactualizados o búsquedas
              interminables.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-135">
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-136">
                <Download className="w-4 h-4 text-gold-500" data-id="element-137" />
                Material 100% digital
              </div>
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-138">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-139" />
                Acceso inmediato
              </div>
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-140">
                <CheckCircle2 className="w-4 h-4 text-gold-500" data-id="element-141" />
                Para todos los niveles
              </div>
            </div>

            {/* CTA */}
            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-lg text-lg transition-colors shadow-[0_0_20px_rgba(201,162,74,0.3)]" data-id="element-142">
              QUIERO MI MEGAPACK AHORA
            </motion.a>

            {/* Trust Badges */}
            <div className="mt-8 flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-slate-400" data-id="element-143">
              <div className="flex items-center gap-1.5" data-id="element-144">
                <ShieldCheck className="w-4 h-4" data-id="element-145" />
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-146">
                <ShieldCheck className="w-4 h-4" data-id="element-147" />
                Pago 100% seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-148">
                <CreditCard className="w-4 h-4" data-id="element-149" />
                Mercado Pago | Tarjeta
              </div>
              <div className="flex items-center gap-1.5" data-id="element-150">
                <Landmark className="w-4 h-4" data-id="element-151" />
                Transferencia
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};